export default __webpack_public_path__ + "static/sunsoaked-banner-desktop-8e68e14ab20eff724051b94316a6b663.webp";